import Vue from 'vue'
import dictApi from '@/api/sys/sysDict.api'
import {concatMapTreeLabel, listToMap} from '@/utils/util'

const dict = {
  state: {
    // 结构1
    valueDataList: {}, // $store.getters.dictType.YES_OR_NO=[{value: 1, label: '是', dictStyle: 'success'}, {value: 0, label: '否', dictStyle: 'danger'}]
    // 结构2（兼容结构1）
    valueDataMap: {}, // $store.getters.dictTypeMap.YES_OR_NO={1:{value: 1, label: '是', dictStyle: 'success'}, 2:{value: 0, label: '否', dictStyle: 'danger'}}
    // 结构3
    labelDataMap: {}, // $store.getters.dictLabel.YES_OR_NO = {1: '是', 0: '否'}
  },
  mutations: {
    putDict: (state, dict) => {
      Vue.set(state.valueDataList, dict.dictType, dict.valueDataList)
      Vue.set(state.valueDataMap, dict.dictType, dict.valueDataMap)
      Vue.set(state.labelDataMap, dict.dictType, dict.labelDataMap)
      // state.type[dict.dictType] = dict.data;
      // state.label[dict.dictType] = dict.labelData;

      // console.log("state.valueDataList", state.valueDataList)
    },
    deleteDict: (state, dict) => {
      Vue.set(state.valueDataMap, dict.dictType, null)
      Vue.set(state.valueDataList, dict.dictType, null)
      Vue.set(state.labelDataMap, dict.dictType, null)
      // state.type[dict.dictType] = null;
      // state.label[dict.dictType] = null;
    },
  },

  actions: {

    /**
     * 字典数据循环查询
     * @param commit
     * @param dictMetasGroup {request: []}
     * @returns {Promise<unknown>}
     */
    doSelectDictCustomBatch({commit}, dictMetasGroup) {
      for(let key in dictMetasGroup) {
        let dictMetas = dictMetasGroup[key];
        let dictTypes = dictMetas.map(item => item.dictType);
        dictMetas[0].request(dictTypes).then(resp => {
          let mapData = resp.data;
          dictMetas.forEach(dictMeta => {
            let putData = {dictType: dictMeta.dictType}
            mapData[dictMeta.dictType] = mapData[dictMeta.dictType].filter(item => item != null);
            let convertedData = dictMeta.fieldNameConverter(dictMeta, mapData[dictMeta.dictType]);// {value, label}
            console.log("--mapData----", convertedData)
            putData.valueDataList = convertedData;
            putData.valueDataMap = listToMap(convertedData,{idField: 'dictValue'});
            putData.labelDataMap = concatMapTreeLabel(convertedData, '/');

            commit('putDict', putData);
          });
        })
      }
    },

    /**
     * 字典数据批量查询
     * @param commit
     * @param dictMetas []
     * @returns {Promise<unknown>}
     */
    doSelectDictBatch({commit}, dictMetas) {
      let dictTypes = dictMetas.map(item => item.dictType);
      dictApi.selectDictBatch(dictTypes).then(data => {
        dictMetas.forEach(dictMeta => {
          let putData = {dictType: dictMeta.dictType};
          let convertedDataList = dictMeta.fieldNameConverter(dictMeta, data[dictMeta.dictType]);

          putData.valueDataList = JSON.parse(JSON.stringify(convertedDataList));
          putData.valueDataMap = listToMap(convertedDataList, {idField: 'dictValue'});
          putData.labelDataMap = concatMapTreeLabel(convertedDataList, {
            splitChar: '/',
            valueField: 'dictValue',
            labelField: 'dictLabel'
          });
          commit('putDict', putData);
        });
      })
    },

    /**
     * 字典树数据批量查询
     *
     * @param commit
     * @param dictMetas
     * @returns {Promise<unknown>}
     */
    doSelectDictTreeBatch({commit}, dictMetas) {
      let dictTreeTypes = [];
      dictMetas.forEach(dictMeta => {
        dictTreeTypes.push({dictType: dictMeta.dictType, treeLevel: dictMeta.treeLevel});
      });
      dictApi.selectDictTreeBatch(dictTreeTypes).then(resp => {
        let data = resp.data
        dictMetas.forEach(dictMeta => {
          // 防止系统中有全部字典，也有只要1级的树字典，所以key带上层级参数
          // 比如，类型是：COUNTRY_AREA，A页面需要省市两级：1,2，则最后key是COUNTRY_AREA1,2
          let dictType = dictMeta.dictType;
          if (dictMeta.treeLevel) {
            dictType += dictMeta.treeLevel;
          }
          let putData = {dictType: dictMeta.dictType};
          let convertedDataList = dictMeta.fieldNameConverter(dictMeta, data[dictType]);
          putData.valueDataList = JSON.parse(JSON.stringify(convertedDataList));
          putData.valueDataMap = listToMap(convertedDataList, {idField: 'dictValue'});
          putData.labelDataMap = concatMapTreeLabel(convertedDataList, {
            splitChar: '/',
            valueField: 'dictValue',
            labelField: 'dictLabel'
          });
          commit('putDict', putData);
        });
      })
    },
  }
}

export default dict


